import { CommonState } from '@models/store.model';
import { createReducer, on } from '@ngrx/store';
import * as commonActions from '@store/actions/common.action';

const initialState: CommonState = {
    loading: 0,
    masterData: {
        airports: [],
        airportMaps: {},
        airlineLabels: {},
        countryDialCodeMaps: {},
        countryDialCodes: [],
        countryDDL: [],
        airCrafts: {},
        inFlightServices: {},
    },
    sharedData: null,
};

export const commonReducer = createReducer<CommonState>(
    initialState,
    on(commonActions.loadDLLAction, (state, { dllName, data }) => {
        return {
            ...state,
            masterData: {
                ...state.masterData,
                [dllName]: data,
            },
        };
    }),
    on(commonActions.loadAirportDLLSuccessAction, (state, { data }) => {
        return {
            ...state,
            masterData: {
                ...state.masterData,
                ...data,
            },
        };
    }),
    on(commonActions.setSharedData, (state, { data }) => {
        return {
            ...state,
            sharedData: data,
        };
    }),
    on(commonActions.loadCountryDialCode, (state, { array, maps }) => {
        return {
            ...state,
            masterData: {
                ...state.masterData,
                countryDialCodes: array,
                countryDialCodeMaps: maps,
            },
        };
    })
);
